const uneditableRoles = ['organization_admin'];

export { uneditableRoles };
